import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { categories } from "@/mocks/meta";

const catName = (slug: string) => categories.find((c) => c.slug === slug)?.name ?? "吃瓜";

// 大图文章卡片
export function ArticleCard({ a, compact = false }: { a: Article; compact?: boolean }) {
  return (
    <Link
      to={`/article/${a.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-100/40 transition-colors hover:border-primary-300/70"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={a.cover}
          alt={a.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-primary-700 backdrop-blur">
          {catName(a.category)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className={`serif font-bold leading-snug text-foreground-950 ${compact ? "text-base" : "text-lg"}`}>{a.title}</h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
        <div className="mt-auto flex items-center gap-3 pt-4 text-xs text-secondary-600">
          <span className="inline-flex items-center gap-1"><i className="ri-calendar-line" />{a.date}</span>
          <span className="inline-flex items-center gap-1"><i className="ri-time-line" />{a.read}</span>
          <span className="ml-auto inline-flex items-center gap-1 text-secondary-500"><i className="ri-eye-line" />{a.views}</span>
        </div>
      </div>
    </Link>
  );
}

// 横向列表行
export function ArticleRow({ a, index }: { a: Article; index?: number }) {
  return (
    <Link
      to={`/article/${a.slug}`}
      className="group flex items-center gap-4 rounded-xl border border-background-200/60 bg-background-100/30 p-3 transition-colors hover:border-accent-300/70 md:gap-5 md:p-4"
    >
      {typeof index === "number" && (
        <span className="display text-2xl font-bold text-accent-500 md:text-3xl">{String(index + 1).padStart(2, "0")}</span>
      )}
      <div className="relative h-16 w-24 flex-shrink-0 overflow-hidden rounded-lg bg-background-200 md:h-20 md:w-32">
        <img src={a.cover} alt={a.title} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 text-xs text-secondary-600">
          <span className="rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-800">{catName(a.category)}</span>
          {a.hot && <span className="inline-flex items-center gap-0.5 font-medium text-primary-600"><i className="ri-fire-fill" /> 热议</span>}
        </div>
        <h3 className="mt-1.5 line-clamp-1 text-sm font-semibold text-foreground-950 md:line-clamp-1 md:text-base">{a.title}</h3>
        <p className="mt-1 hidden text-xs text-foreground-500 md:line-clamp-1">{a.excerpt}</p>
        <div className="mt-1.5 flex items-center gap-3 text-xs text-secondary-500">
          <span>{a.date}</span>
          <span className="inline-flex items-center gap-1"><i className="ri-time-line" />{a.read}</span>
        </div>
      </div>
    </Link>
  );
}